/* eslint-disable */
'use strict'

/**
 * Based on https://github.com/rauschma/enums
 */
function copyOwnFrom(target, source) {
  Object.getOwnPropertyNames(source).forEach(function(propName) {
    Object.defineProperty(target, propName,
            Object.getOwnPropertyDescriptor(source, propName))
  })
  return target
}

function Symbol(name, props) {
  this.name = name
  if (props) {
    copyOwnFrom(this, props)
  }
  Object.freeze(this)
}
/** We don't want the mutable Object.prototype in the prototype chain */
Symbol.prototype = Object.create(null)
 /*eslint-disable */
Symbol.prototype.constructor = Symbol
/**
 * Without Object.prototype in the prototype chain, we need toString()
 * in order to display symbols.
 */
Symbol.prototype.toString = function() {
  return '|' + this.name + '|'
}
Object.freeze(Symbol.prototype)

const Enum = function(obj) {
  if (arguments.length === 1 && obj !== null && typeof obj === 'object') {
    Object.keys(obj).forEach(function(name) {
      this[name] = new Symbol(name, obj[name])
    }, this)
  } else {
    Array.prototype.forEach.call(arguments, function(name) {
      this[name] = new Symbol(name)
    }, this)
  }
  Object.freeze(this)
}

Enum.prototype.symbols = function() {
  return Object.keys(this).map(
        function(key) {
          return this[key]
        }, this
    )
}

Enum.prototype.contains = function(sym) {
  if (!sym || !(sym instanceof Symbol)) return false
  return sym.name && this[sym.name] === sym
}

/**
 * Find enum symbol by its value.
 * @param value     Both integer and numberic string are acceptable.
 */
Enum.prototype.getEnumByValue = function(value) {
  const valueNum = parseInt(value, 10)
  if (isNaN(valueNum)) {
    throw new Error('parameter value must be an integer')
  }
  let result = null
  const thisEnum = this
  Object.keys(this).forEach(function(val, idx, arr) {
    if (thisEnum[val].value === valueNum) {
      result = thisEnum[val]
    }
  })
  return result
}

/**
 * Find next enum symbol immediately following the given one.
 * @param curr      Current enum symbol.
 * @return next symbol or null.
 */
Enum.prototype.next = function(curr) {
  let result = null
  let meetCurr = false
  const thisEnum = this
  Object.keys(this).forEach(function(val, idx, arr) {
    if (meetCurr && result == null) {
      result = thisEnum[val]
    }
    if (thisEnum[val] === curr) {
      meetCurr = true
    }
  })

  return result
}

export { Enum, Symbol }



// WEBPACK FOOTER //
// ./src/utils/enums.js